module.exports = __webpack_public_path__ + "img/4ce106b.png";